const processPolyfill = {
  env: {
    NODE_ENV: (typeof window !== 'undefined' && window.railsEnv) || 'development',
    STRIPE_PUBLISHABLE_KEY: (typeof window !== 'undefined' && window.stripePublishableKey) || '',
    RAILS_ENV: (typeof window !== 'undefined' && window.railsEnv) || 'development',
  },
  browser: true,
  version: '',
  versions: {},
  platform: 'browser',
}

if (typeof globalThis !== 'undefined' && typeof globalThis.process === 'undefined') globalThis.process = processPolyfill
if (typeof window !== 'undefined' && typeof window.process === 'undefined') window.process = processPolyfill
if (typeof global !== 'undefined' && typeof global.process === 'undefined') global.process = processPolyfill
